import PropTypes from "prop-types";

import { strCode } from "../../../../consts";
import { appsService, log,t } from "../../../../services";

import {
  FlexContainers,
  IconButton,
  SVG,
  TextOverflowWrapper,
  WrapperContainer
} from "../../../../components";
import { FileNameTitle } from "../styled";

export const TranslationCell = ({ cell }) => {
  const value = cell?.value.split("/").at(-1);

  const fetchJson = async () => {
    try {
      const response = await appsService.getLocalization(cell.value);

      const jsonBlob = new Blob([JSON.stringify(response.data)], {
        type: "application/json"
      });

      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(jsonBlob);
      downloadLink.download = cell.row.original.name;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      log.error("Error fetching JSON", error);
      throw error;
    }
  };

  return (
    <>
      {
        <WrapperContainer gap={8} Container={FlexContainers.FlexRowCenter} alignItems={"center"}>
          {value && <SVG.FileIcon />}
          <TextOverflowWrapper>
            <FileNameTitle isEmpty={!value}>{value || t(strCode.NO_CHOSEN_FILE)}</FileNameTitle>
          </TextOverflowWrapper>

          {value && (
            <IconButton
              hasHoverCircle
              isLarge
              onClick={fetchJson}
              tooltipLabel={t(strCode.DOWNLOAD_FILE_TOOLTIP)}>
              <SVG.DownloadIcon />
            </IconButton>
          )}
        </WrapperContainer>
      }
    </>
  );
};

TranslationCell.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.string.isRequired,
    row: PropTypes.shape({
      original: PropTypes.shape({
        name: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired
};
